/* eslint-disable import/prefer-default-export */
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { selectors } from './sectionStudent';

export type Student = {
  id: number;
  last_login: string;
  email: string;
  first_name: string;
  last_name: string;
  is_active: boolean;
  date_joined: string;
  grade_level: number;
  third_party_id: string | null;
};

export const useSectionStudent = () => {
  const { sectionId } = useParams();
  const studentList = useSelector((state) => selectors.getStudentList(state, sectionId));
  return studentList as Student[];
};

export const useSectionStudentWithFilter = (sectionId?: number): Student[] => {
  const { sectionId: sectionIdFromParams } = useParams();
  const effectiveSectionId = sectionId ?? sectionIdFromParams;

  return useSelector((state) =>
    selectors.getStudentListWithFilter(state, effectiveSectionId),
  );
};
